var map = {
	"./android-icon.svg": 2168,
	"./app-img.png": 2169,
	"./app-qr-code-bg.png": 2170,
	"./apple-icon.svg": 2171,
	"./contact-bg.png": 2172,
	"./contact-us-bg.jpg": 2173,
	"./contact-us-main-bg.webp": 2174,
	"./qr-bg.png": 2175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2167;